export const feelingList1 = [
  "awed",
  "challenged",
  "enraptured",
  "respected",
  "adored",
  "confident",
  "encouraged",
  "safe",
  "inspired",
  "invigorated",
  "fulfilled",
  "wanted",
  "special",
  "proud",
  "enlightened",
  "joyous",
  "hopeful",
  "productive",
  "ardent",
  "free",
  "calm",
  "spellbound",
  "understood",
  "welcome",
  "grand",
  "consoled",
  "honored",
  "treasured",
  "victorious",
  "recognized",
  "entertained",
];

export const feelingList2 = [
  "amazed",
  "driven",
  "enthralled",
  "valued",
  "loved",
  "capable",
  "supported",
  "secure",
  "motivated",
  "alive",
  "at peace",
  "desired",
  "uncommon",
  "proud",
  "illuminated",
  "content",
  "upbeat",
  "effective",
  "aflame",
  "liberated",
  "relaxed",
  "entranced",
  "seen",
  "included",
  "sublime",
  "comforted",
  "esteemed",
  "cherished",
  "triumphant",
  "appreciated",
  "amused",
];
